<template>
    <div class="result-grid">
        <div class="safe">
            <div class="title">
                <h2>Your secret is safe!</h2>
            </div>
            <div class="details">
                <p>It is available for <span class="emphasis">7 days</span>!</p> 
                <p>It can be <span class="emphasis">retrieved once</span> then it is <span class="emphasis">permanently deleted</span>!</p> 
            </div>
        </div>
        <div class="result">
            <div class="work-together">
                <h2>work.</h2>
                <h2>together.</h2>
            </div>
            <textarea id="secretLink" class="result-link" :value="secretLink" readonly/>
            <button class="dark-button" @click="copyLink">Copy link</button>
        </div>
        <Alert v-if="showAlert" @close="showAlert=false">
            <span slot="message">Link was copied to clipboard.</span>
        </Alert>
    </div>
</template>
<script>
export default {
    components: {
        Alert: () => import("../AlertModal.vue")
    },
    props: {
        secret: String,
        appUrl: String
    },
    data: () => {
        return {
            secretLink: "",
            showAlert: false
        }
    },
    mounted() {
        this.secretLink = this.appUrl + 'get?s=' + this.secret
    },
    methods: {
        copyLink() {
            let copyText = document.getElementById("secretLink")
            copyText.select();
            document.execCommand("copy")
            this.showAlert = true
        }
    }
}
</script>
<style lang="scss">
.result-grid {
    display: 1fr;
    grid-template-columns: auto;
    min-height: 60vh;
    max-width: 100vw;
    .safe {
        position: relative;
        background-color: $primary;
        padding: 20px;
        @include BoxShadow(8);
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        .title, .details p {
            color: #FFF;
            font-size: 26px;
        }
        .details {
            margin: 60px;
            p {
                margin: 5px 0;
                padding: 0;
            }
        }
        .emphasis {
            color: $secondary;
        }
    }
    .result {
        grid-column: 1;
        background-color: $light;
        padding: 50px;
        height: fit-content;
        @include BoxShadow(4);
        .work-together {
            margin: 20px 0;
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        h2 {
            text-align: left;
            line-height: .9em;
            margin: 0;
            padding: 0;
        }
        .result-link {
            margin-top: 90px;
            font-size: 1em;
            border: none;
            resize: none;
            outline: none;
            text-align: center;
            word-wrap: break-word;
            overflow: hidden;
            width: 90%;
            min-height: 17vh;
            background-color: $light;
            color: $secondary;
            &::selection {
                background-color: $primary;
            }
        }
    }
    .dark-button {
        color: $light;
        background: linear-gradient(280deg, $primary 50%, #FFF 50%);
        &::after {
            background: linear-gradient(280deg, #FFF 50%, $primary 50%);
        }
        &, &::after {
            background-size: 300%;
            background-position: 100%;
            transition: .5s;
        }
        &:hover, &:hover::after {
            color: $dark;
            background-position: 0;
        }
    }
}

@media screen and (max-width: 700px) {
    .result-grid {
        .safe {
            .title, .details p {
                font-size: 16px;
                line-height: 1em;
            }
            .details {
                margin: 0px;
            }
            
            .title h2{
                font-size: 24px;
            }
        }
        .result {
            padding: 0;
            padding-top: 30px;
            .result-link {
                margin: 60px 5px;
                margin-bottom: 0;
                min-height: 33vh;
            }
        }
    }
    
}

</style>
